import { ContractSummary } from "@/api/ContractSummary";
import apiClient from "./core/ApiClient";
import { WorkModelEntry } from "@/api/WorkModelEntry";
import { WorkModelPreview } from "@/api/WorkModelPreview";
import { WorkModelsListResponse } from "@/api/WorkModelsListResponse";
import { WorkModelsPreviewRequest } from "@/api/WorkModelsPreviewRequest";
import { WorkModelsPreviewResponse } from "@/api/WorkModelsPreviewResponse";
import { WorkModelsStoreRequest } from "@/api/WorkModelsStoreRequest";
import { WorkModelsSummaryResponse } from "@/api/WorkModelsSummaryResponse";
import { StoreResponse } from "@/api/StoreResponse";
import { MonthlySummary } from "@/api/MonthlySummary";
import { WorkModelsYearlyResponse } from "@/api/WorkModelsYearlyResponse";

const add = (ps: WorkModelEntry): Promise<number> => {
  let payload: WorkModelsStoreRequest = {
    entry: ps,
  };
  return apiClient
    .post<WorkModelsStoreRequest, StoreResponse>(
      `/api/users/${ps.userId}/workmodels`,
      payload
    )
    .then((r) => r.id);
};

const update = (ps: WorkModelEntry): Promise<number> => {
  let payload: WorkModelsStoreRequest = {
    entry: ps,
  };
  return apiClient
    .put<WorkModelsStoreRequest, StoreResponse>(
      `/api/users/${ps.userId}/workmodels`,
      payload
    )
    .then((r) => r.id);
};

const remove = (userId: number, id: number): Promise<void> =>
  apiClient.delete<void>(`/api/users/${userId}/workmodels/${id}`);

const findAll = (userId: number): Promise<WorkModelEntry[]> =>
  apiClient
    .get<WorkModelsListResponse>(`/api/users/${userId}/workmodels`)
    .then((r) => r.results.concat([]));

const preview = (ps: WorkModelsPreviewRequest): Promise<WorkModelPreview[]> => {
  return apiClient
    .post<WorkModelsPreviewRequest, WorkModelsPreviewResponse>(
      `/api/workmodels/preview`,
      ps
    )
    .then((r) => r.results.concat([]));
};

// handle the case when it is not set, in this case the service returns 404
const contractSummary = (userId: number): Promise<ContractSummary | null> =>
  apiClient
    .get<WorkModelsSummaryResponse>(`/api/users/${userId}/workmodels/contract`)
    .then((r) => r.summary).catch(err => {
      if (err.status === 404) {
        // means the user has no valid contract set (probably at all)
        return null;
      } else {
        // rethrow if is a different error
        throw err;
      }
    });

  // yearly report  
  const yearlyReport = (userId: number, year: number): Promise<MonthlySummary[]> =>
  apiClient
    .get<WorkModelsYearlyResponse>(`/api/users/${userId}/workmodels/yearly/${year}`)
    .then((r) => [...r.results]).catch(err => {
      if (err.status === 404) {
        // means the user has no valid contract set (probably at all)
        return [];
      } else {
        // rethrow if is a different error
        throw err;
      }
    });

export const workmodelService = {
  add,
  update,
  remove,
  findAll,
  preview,
  contractSummary,
  yearlyReport
};
